import React from 'react';
import { Link } from 'react-router-dom';
import { Baby, Facebook, Instagram, Youtube, Mail } from 'lucide-react';
import logo from '../assets/Logo.png';
const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-pink-50 to-white border-t border-pink-100 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-pink-400 to-pink-600 rounded-full flex items-center justify-center">
                <img
                  src={logo}
                  alt="Logo"
                  className="w-8 h-8 object-contain"
                />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-pink-500 to-pink-700 bg-clip-text text-transparent">
                AN NHI
              </span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              Đồng hành cùng các mẹ bầu Việt Nam trong hành trình mang thai và nuôi dạy con.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Liên kết nhanh</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-pink-600 text-sm transition-colors">
                  Trang chủ
                </Link>
              </li>
              <li>
                <Link to="/pregnancy-tracker" className="text-gray-600 hover:text-pink-600 text-sm transition-colors">
                  Theo dõi thai kỳ
                </Link>
              </li>
              <li>
                <Link to="/community" className="text-gray-600 hover:text-pink-600 text-sm transition-colors">
                  Cộng đồng
                </Link>
              </li>
              <li>
                <Link to="/appointments" className="text-gray-600 hover:text-pink-600 text-sm transition-colors">
                  Đặt lịch hẹn
                </Link>
              </li>
              <li>
                <Link to="/medical-records" className="text-gray-600 hover:text-pink-600 text-sm transition-colors">
                  Hồ sơ y tế
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Hỗ trợ</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms-of-service" className="text-gray-600 hover:text-pink-600 text-sm transition-colors">
                  Điều khoản sử dụng
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-600 hover:text-pink-600 text-sm transition-colors">
                  Chính sách bảo mật
                </Link>
              </li>
              <li>
                <Link to="/data-deletion" className="text-gray-600 hover:text-pink-600 text-sm transition-colors">
                  Hướng dẫn xóa dữ liệu
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Kết nối</h3>
            <div className="space-y-3">
              <a href="mailto:caoanh0928@gmail.com" className="flex items-center space-x-2 text-gray-600 hover:text-pink-600 text-sm transition-colors">
                <Mail className="w-4 h-4" />
                <span>caoanh0928@gmail.com</span>
              </a>
              <div className="flex space-x-3 pt-2">
                <a
                  href="https://www.facebook.com/AnNhi.TrolyMebau"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 bg-pink-100 hover:bg-pink-200 rounded-full flex items-center justify-center transition-colors"
                >
                  <Facebook className="w-5 h-5 text-pink-600" />
                </a>
                <a
                  href="#"
                  className="w-9 h-9 bg-pink-100 hover:bg-pink-200 rounded-full flex items-center justify-center transition-colors"
                >
                  <Instagram className="w-5 h-5 text-pink-600" />
                </a>
                <a
                  href="#"
                  className="w-9 h-9 bg-pink-100 hover:bg-pink-200 rounded-full flex items-center justify-center transition-colors"
                >
                  <Youtube className="w-5 h-5 text-pink-600" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-pink-100 mt-8 pt-8 text-center">
          <p className="text-gray-600 text-sm">
            © 2026 AN NHI. Tất cả quyền được bảo lưu.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Nội dung được cung cấp chỉ mang tính chất tham khảo. Vui lòng tham khảo ý kiến bác sĩ.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;